import { render, staticRenderFns } from "./MenuPerfil.vue?vue&type=template&id=d69f5a3a"
import script from "./MenuPerfil.vue?vue&type=script&lang=js"
export * from "./MenuPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports